export default __webpack_public_path__ + "static/media/navigation.3459ef52.svg";